import ReactApexChart from "react-apexcharts";
import { Typography } from "antd";
import lineChart from "./lineChart";

function LineChart({ creationTimeline }) {
  const { Title } = Typography;

  const timelineData = Object.entries(creationTimeline);

  const formatReadableDate = (isoDate) => {
    const date = new Date(isoDate);
    return `${date.toLocaleString("default", {
      month: "short",
    })} ${date.getDate()}, ${date.getFullYear()}`;
  };

  const dates = timelineData.map((entry) => formatReadableDate(entry[0]));
  const counts = timelineData.map((entry) => entry[1]);
  const lineWidth = Math.max(720, dates.length * 64);
  const tickAmount = Math.min(dates.length, 8);

  if (!dates.length) {
    return (
      <div className="dashboard-empty-state">No expert growth data yet.</div>
    );
  }

  const updatedLineChartOptions = {
    ...lineChart.options,
    grid: {
      ...lineChart.options.grid,
      borderColor: "rgba(237, 248, 242, 0.12)",
    },
    xaxis: {
      ...lineChart.options.xaxis,
      categories: dates,
      tickAmount,
      labels: {
        ...lineChart.options.xaxis.labels,
        style: {
          ...lineChart.options.xaxis.labels.style,
          colors: dates.map(() => "#d6e9df"),
        },
      },
    },
    yaxis: {
      ...lineChart.options.yaxis,
      labels: {
        ...lineChart.options.yaxis.labels,
        style: {
          ...lineChart.options.yaxis.labels.style,
          colors: ["#d6e9df"],
        },
      },
    },
    tooltip: {
      ...lineChart.options.tooltip,
      theme: "dark",
    },
    colors: ["#5FCBA0"], // Adding the Digital Shifts color
  };

  const updatedLineChartSeries = [
    {
      name: "Number of Experts",
      data: counts,
    },
    // ... other series data if you have them
  ];

  return (
    <div className="dashboard-panel">
      <div className="dashboard-panel__header">
        <div className="dashboard-panel__header-copy">
          <span className="dashboard-panel__eyebrow">Growth</span>
          <Title level={5}>Expert Creation Over Time</Title>
          <span className="dashboard-panel__subtext">
            Follow expert sign-up momentum and identify stronger acquisition
            periods.
          </span>
        </div>
        <span className="dashboard-panel__metric">{counts.length}</span>
      </div>
      <div className="dashboard-panel__chart">
        <div className="dashboard-panel__chart-inner" style={{ minWidth: lineWidth }}>
        <ReactApexChart
          options={updatedLineChartOptions}
          series={updatedLineChartSeries}
          type="area"
          height={350}
          width="100%"
        />
        </div>
      </div>
    </div>
  );
}

export default LineChart;
